import { render } from "./StOnTheWayList.vue?vue&type=template&id=d3561f6a&scoped=true"
import script from "./StOnTheWayList.vue?vue&type=script&lang=js"
export * from "./StOnTheWayList.vue?vue&type=script&lang=js"

import "./StOnTheWayList.vue?vue&type=style&index=0&id=d3561f6a&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3561f6a"]])

export default __exports__